import {ChangeDetectionStrategy, Component, computed, DestroyRef, Input} from '@angular/core';
import {MatIconModule} from "@angular/material/icon";

import {MatButtonModule} from "@angular/material/button";
import {AksjeeierKomponent} from "../aksjeeier/aksjeeier";
import {TranslateModule} from "@ngx-translate/core";
import {MatDialog, MatDialogModule} from "@angular/material/dialog";
import {AksjeeierEnkelModell, AksjeeierId, Aksjeeiertype, TilgangsrolleMedlem} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {FormaterProsentPipe} from "felles-ng2/pipes/FormaterProsentPipe";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {MatMenuModule} from "@angular/material/menu";
import {AksjenummerintervallerPipe} from "felles-ng2/pipes/AksjenummerintervallerPipe";
import {InlineMeldingKomponent} from "web-ng2/delt/komponenter/inline-melding/inline-melding";
import {LukkAbonnementer} from "felles-ng2/infrastruktur/rxjs/LukkAbonnementer";
import {MatTooltipModule} from "@angular/material/tooltip";
import {Aksjeeiersortering, BeholdningerModellBase, BeholdningModellBase, Valideringsfeil} from "web-ng2/moduler/aksjeeierbok/komponenter/aksjeeier-liste/BeholdningModellBase";
import {AksjeeierRedigerDialogKomponent} from "web-ng2/moduler/aksjeeierbok/modale/aksjeeier-rediger-dialog/aksjeeier-rediger-dialog";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {AntallAksjerPerAksjeklasseKomponent} from "web-ng2/moduler/aksjeeierbok/komponenter/antall-aksjer-per-aksjeklasse/antall-aksjer-per-aksjeklasse";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {erTomEllerNil} from "felles-ng2/støttefunksjoner/strenger";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {AksjeeierRedigerKommentarDialogKomponent} from "web-ng2/moduler/aksjeeierbok/modale/aksjeeier-rediger-beholdning-kommentar/aksjeeier-rediger-beholdning-kommentar-dialog";
import {GruppeDatatjeneste} from "felles-ng2/tjenester/datalager/GruppeDatatjeneste";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";

const debug = initDebugger('AksjeeierListeKomponent');


@Component({
    selector: 'aksjeeier-liste',
    templateUrl: './aksjeeier-liste.html',
    styleUrls: ['./aksjeeier-liste.scss'],
    imports: [
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule,
    TranslateModule,
    FormaterProsentPipe,
    AksjeeierKomponent,
    FormaterPlainDatePipe,
    AksjenummerintervallerPipe,
    InlineMeldingKomponent,
    AntallAksjerPerAksjeklasseKomponent,
    HtmlFormatertKomponent
],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AksjeeierListeKomponent {

    modell!:BeholdningerModell;
    ekspandertAksjeeierId: AksjeeierId | null = null;

    private ab = new LukkAbonnementer();

    tilgangTilRediger =  computed(() => this.brukerkontekstTilbyder.autentisertBruker().inneharTilgangsrolleIGruppe(TilgangsrolleMedlem.skrive, this.gruppeDatatjeneste.aktivGruppeIkkeNull().id));

    constructor(public dialog: MatDialog, private destroyRef: DestroyRef, private oversettelser:Oversettelser,private gruppeDatatjeneste: GruppeDatatjeneste, private brukerkontekstTilbyder:BrukerkontekstTilbyder) {
        this.ab.registrerHosDestroyRef(this.destroyRef);
    }

    @Input({required: true}) set aksjeeiere(aksjeeiere: AksjeeierEnkelModell[]) {
         this.modell = new BeholdningerModell(aksjeeiere, this.ab, this.oversettelser);
    }

    visSkjulDetaljer(modell: BeholdningModell) {
        this.ekspandertAksjeeierId = this.viserDetaljerFor(modell) ? null : modell.aksjeeier.id;
    }

    viserDetaljerFor(modell: BeholdningModell) {
        return this.ekspandertAksjeeierId === modell.aksjeeier.id;
    }

    rediger(aksjeeier: BeholdningModell) {
         AksjeeierRedigerDialogKomponent.vis(Promise.resolve(aksjeeier.aksjeeier), this.dialog);
    }

    redigerKommentar(aksjeeier: AksjeeierEnkelModell) {
        if(erNil(aksjeeier.naavaerendeBeholdning)) return;
        AksjeeierRedigerKommentarDialogKomponent.vis(Promise.resolve(aksjeeier), this.dialog);
    }
}

class BeholdningerModell extends BeholdningerModellBase<BeholdningModell> {
    aksjenummerSomOverlapper: string[] = [];

    static tomBeholdningerModell(oversettelser: Oversettelser) {
        return new BeholdningerModell([], new LukkAbonnementer(), oversettelser);
    }

    constructor(aksjeeiere: AksjeeierEnkelModell[], public ab: LukkAbonnementer, public oversettelser:Oversettelser) {
        super(aksjeeiere, ab, Aksjeeiersortering.uendret, oversettelser);
        this.beholdninger.forEach(beholdning => beholdning.initValideringsfeil());
        this.aksjenummerSomOverlapper = this.beholdninger
          .filter(beholdning => erIkkeNil(beholdning.aksjenummerValideringsfeil?.overlapperAnnen))
          .map(beholdning => beholdning.aksjenummerValideringsfeil!.overlapperAnnen!); //vi vet her at overlapperAnnen er ikke-null
    }

    override nyBeholdningModell(aksjeeier: AksjeeierEnkelModell, forelder: BeholdningerModellBase<BeholdningModell>): BeholdningModell {
        return new BeholdningModell(aksjeeier, forelder);
    }
}

class BeholdningModell extends BeholdningModellBase {
    aksjenummerValideringsfeil: Valideringsfeil | null = null;
    harAdvarsler = false;
    advarslerTooltipTekst = '';

    constructor(aksjeeier: AksjeeierEnkelModell, forelder: BeholdningerModellBase<BeholdningModell>) {
        super(aksjeeier, forelder)
        this.initAdvarsler();
    }

    override aksjenummerFeltverdi(): string {
        return this.aksjeeier.naavaerendeBeholdning?.aksjenummer ?? '';
    }

    initValideringsfeil() {
        this.aksjenummerValideringsfeil = this.validerAksjenummer(this.aksjenummerFeltverdi());
    }

    initAdvarsler() {
        this.harAdvarsler = false;

        const mangler: string[] = [];
        if (erTomEllerNil(this.aksjeeier.adresse)) mangler.push(this.forelder.oversettelser.oversett(i18n('Adresse')));
        if (erTomEllerNil(this.aksjeeier.epost)) mangler.push(this.forelder.oversettelser.oversett(i18n('E-post')));
        if (this.aksjeeier.type == Aksjeeiertype.person && erNil(this.aksjeeier.foedselsdato)) mangler.push(this.forelder.oversettelser.oversett(i18n('Fødselsdato')));
        if (this.aksjeeier.type == Aksjeeiertype.organisasjon && erTomEllerNil(this.aksjeeier.organisasjonsnummer)) mangler.push(this.forelder.oversettelser.oversett(i18n('Organisasjonsnummer')));

        if (mangler.length == 0) return;
        this.advarslerTooltipTekst = this.forelder.oversettelser.oversett(i18n('Følgende informasjon mangler: {mangler}'), {mangler: mangler.join(', ')});
        this.harAdvarsler = true;
    }
}
